import React from "react";
import AdminHeader from "../../components/Layout/AdminHeader";
import AdminSideBar from "../../components/Admin/Layout/AdminSideBar";
import AdminOfferManagement from "../../components/Admin/AdminOfferManagement";

const AdminOfferManagementPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader activeMenuItem={21} />
      <div className="flex pt-16 sm:pt-20">
        <div className="hidden 800px:block w-[300px] fixed left-0 top-[75px] h-[calc(100vh-70px)] z-10">
          <AdminSideBar active={21} />
        </div>
      </div>
    </div>
  );
};

export default AdminOfferManagementPage;
